import GeneralInformationPage from "./general-information"

export default GeneralInformationPage
